import Vue from 'vue'
import Vuex from 'vuex'
import auth from './auth'
import report from './report'
import axios from 'axios'

axios.defaults.withCredentials = true
axios.defaults.baseURL = process.env.VUE_APP_API_URI
axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';
axios.defaults.headers.common['Authorization'] = `Bearer ${sessionStorage.getItem('auth_token')}`;

Vue.use(Vuex)

export default new Vuex.Store({
    modules: {
        auth,        
        report
    }
})